import PropTypes from 'prop-types';

const ReimbursementDue = ({reimbursementDue}) => {

  return (
    <div className='flex justify-between'>
      <p className='text-[22px] font-semibold'>Reimbursement Due</p>
      <p className='text-[18px] font-semibold'>{`£${reimbursementDue.toFixed(2)}`}</p>
    </div>
  )
}

export default ReimbursementDue;

ReimbursementDue.propTypes = {
  reimbursementDue: PropTypes.number.isRequired,
};